import styled from 'styled-components';
import { Colors } from 'modules/theme';

/** Unified title for all Settings sections */
const SettingsSectionTitle = styled.h2`
  font-size: 16px;
  font-weight: 600;
  color: ${Colors.black};
  margin: 0 0 20px 0;
  padding: 0;
  font-family: inherit;
  line-height: 1.4;
  @media (max-width: 767px) {
    margin-bottom: 16px;
  }
`;

export default SettingsSectionTitle;
